import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import React, { useState } from 'react';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "../admin/table.css";
import { useSubjectStore } from '../../stores';
import { data } from 'jquery';

const sortCaretEle = (order, column) => {
  const Up = () => <span style={{ content: '', borderBottom: 0, borderTop: "4px dashed" }} className='caret'></span>
  const Down = () => <span style={{ content: '', borderTop: 0, borderBottom: "4px dashed" }} className='caret'></span>
  if (!order) return (<span>&nbsp;&nbsp;<Up />&ensp;<Down /></span>);
  else if (order === 'asc') return (<span>&nbsp;&nbsp;<Down /></span>);
  else if (order === 'desc') return (<span>&nbsp;&nbsp;<Up /></span>);
  return null;
}
const headerSortingStyle = { backgroundColor: '#c8e6c9' };
const TableSubjects = ({ openModal, setOpenModal,data,setOpenDeleteModal, deleteSubRef}) => {
  const options = {
    // pageStartIndex: 0,
    sizePerPage: 5,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true
  };
  const columns = [
    
    {
      dataField: 'name',
      text: 'Subject',
      sort: true,
      sortCaret: sortCaretEle,
      headerSortingStyle: headerSortingStyle,
    
    },
    {
      dataField: 'Delete',
      text: '',
    
      formatter: (content, row, rowIndex, formatExtraData) => {
        return (
          <button className='btn btn-danger' onClick={(e) => {setOpenDeleteModal(true); e.preventDefault();deleteSubRef.current = row }}>Delete</button>
        )
      }
    }
  ];
  
  return (
    <>
      <BootstrapTable
        keyField="id"
        data={data}
        columns={columns}
        pagination={paginationFactory(options)}
        striped
        hover
        headerClasses='tableHead'
        condensed
        bordered={false}
      />
    </>
  );
}
export default TableSubjects;